import Container from './Container/RecruiterList';

export default Container;